import epilogDiscovery from "../img/latestNews/epilogDiscovery.png";
import talLondonImg from "../img/latestNews/talLondon.jpg";
import bruceWelcomeImg from "../img/latestNews/bruceWelcome.jpg";
import davidCasarettImg from "../img/latestNews/DavidCasarett.jpg";
import mixiiIsraelImg from "../img/latestNews/MixiiIsrael.svg";
import cTechOct2022Img from "../img/latestNews/CTechOct22.svg";
import hlthLasVegasImg from "../img/latestNews/hlth.svg";
import orCalcalistImg from "../img/latestNews/OrCalcalist.svg";
import researchJpsmImg from "../img/latestNews/ResearchInbal.svg";
import april2025Img from "../img/latestNews/April2025.svg";
import aahpmPosterImg from "../img/latestNews/aahpmPosterImg.png";
import aahpmPosterPdf from "../img/latestNews/aahpmPoster.pdf";

const latestNewsData = [
    {
        title: 'New Duke IRB Study Shows Epilog Reduces Hospital Admissions by 23% ',
        description: 'Epilog\'s collaboration with Duke University Health System has shown strong results in extending continuous, AI-enabled support to patients with serious, complex conditions between clinical visits. Adding Epilog to standard palliative care boosted hospital admission reduction from 27% to 50%, with 53% of patients engaging in meaningful goals-of-care conversations and and a 47% enrollment rate among eligible patients. These results demonstrate how digital tools can extend continuous, supportive care beyond the clinic walls.',
        img: aahpmPosterImg,
        date: 'March 2026',
        buttonText: "See results",
        link: aahpmPosterPdf,
    },
    {
        title: 'Epilog Presented at AAHPM 2026 Annual Assembly, San Diego',
        description: 'Epilog was featured in research presented by Dr. David Casarett, Chief of Palliative Care at Duke University Health System, at the American Academy of Hospice and Palliative Medicine\'s Annual Assembly in San Diego. The study evaluated the feasibility of implementing Epilog\'s AI conversational platform in an outpatient palliative care clinic, finding that adding Epilog to standard palliative care boosted hospital admission reduction from 27% to 50%.',
        img: davidCasarettImg,
        date: 'March 2026',
        buttonText: "",
        link: "",
    },
    {
        title: 'Serious illness Care Research with Duke University School of Medicine',
        description: 'Epilog\'s COO, MD Inbal Mayan, coauthored research on in the Journal of the American Geriatric Society with the amazing team at University of California, San Francisco. We looked at trends of utilization of hospice for people with dementia and cancer and examined gaps by race and ethnicity.',
        img: researchJpsmImg,
        date: 'January 2026',
        buttonText: "Read more",
        link: "https://www.linkedin.com/posts/inbalmayanmd_trends-in-hospice-use-among-older-adults-activity-7400263918033711104-t9RD?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAAWjB88BjeZR-4FM-qgWgWwQOSXSF2F-s-I",
    },
    {
        title: 'Epilog featured on The Economy Channel, Channel 10 News, Israel',
        description: 'We\'re proud to see our story shared on national TV! Watch our CTO & Co-Founder, Or Bar Tal, share how we\'re using AI to improve care for patients with serious illnesses conditions.',
        img: orCalcalistImg,
        date: 'October 2025',
        buttonText: "Watch video",
        link: "https://vod.tv10.co.il/live,12057/rw-10---rw-hklklh-l-yrl,790191/2025-10-20/hdbr-hb,908971",
    },
    {
        title: 'Epilog @ hlth, Las vegas',
        description: 'Epilog CEO Tal Shapsa Heiman and COO MD Inbal Mayan concluded a very successful week at HLTH, meeting our investors, customers, and many new partners and friends.\nWatch Bruce Broussard, former CEO of Humana, highlighting Epilog as an example for how to use data efficiently to generate meaningful patient engagement and trust.',
        img: hlthLasVegasImg,
        date: 'October 2025',
        buttonText: "Watch video",
        link: "https://drive.google.com/file/d/1Xwh7HwR17VzUneWXUEEGlj-6iQ7O9hp9/view?usp=sharing",
    },
    {
        title: 'Epilog as part of the Dream Team from Calcalist at Mind the Tech conference in London',
        description: 'It was a privilege to take part in the #dreamteam of this year\'s Mind the Tech alongside all the other amazing founders! Epilog was featured in the build up to the conference in C Tech here, and then again featuring our CEO Tal Shapsa Heiman\'s presentation here',
        img: talLondonImg,
        date: 'September 2025',
        buttonText: "Read article",
        link: "https://www.calcalistech.com/ctechnews/article/nbg33ryop",
    },
    {
        title: 'Welcome Bruce!',
        description: 'We are proud and thrilled to welcome Bruce Broussard, former CEO of Humana, as Epilog\'s acting chair.\n\nBruce brings unparalleled insight into Medicare Advantage, value-based care, and the systemic challenges that prevent individuals with serious illness from getting the support they truly need.',
        img: bruceWelcomeImg,
        date: 'July 2025',
        imgStyle: { objectFit: 'cover', objectPosition: 'bottom' },
    },
    {
        title: 'Published work in conjunction with Duke Health',
        description: 'We\'re honored to see our work published in a leading medical journal.\nThis study shows how our digital companion can meaningfully improve access to palliative care.\n\nHuge thanks to our team and our amazing collaborators at #DukeHealth!',
        img: april2025Img,
        date: 'April 2025',
        buttonText: "Read article",
        link: "https://www.jpsmjournal.com/article/S0885-3924(25)00593-7/abstract",
    },
    {
        title: 'Startup Pitch winners at EY track in the MIXiii Health-Tech.IL 2025!',
        description: 'We\'re proud to share that Epilog has won the startup pitch competition at the EY track in the MIXiii Health-Tech.IL 2025!\n\nThis recognition strengthens our mission to revolutionize AI-powered patient support, and we\'re just getting started.',
        img: mixiiIsraelImg,
        date: 'February 2025',
        buttonText: "Read article",
        link: "https://www.linkedin.com/posts/inbalmayanmd_epilog-won-the-startup-pitch-competition-at-the-activity-7400263918033711104-t9RD?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAAWjB88BjeZR-4FM-qgWgWwQOSXSF2F-s-I",
    },

    {
        title: 'Epilog and Discovery Health Revolutionize Care for Managing Complex Medical Conditions',
        description: 'Discovery is partnering with Epilog, a pioneering digital platform designed specifically to help individuals manage these complex journeys',
        img: epilogDiscovery,
        date: 'August 2024',
        buttonText: "Read article",
        link: "/article",
    },
    {
        title: 'C Tech features Epilog and City Science Center University collaboration',
        description: 'Epilog featured in C Tech as one of Assuta\'s RISE with US program in collaboration with Philadelphia-based University City Science Center',
        img: cTechOct2022Img,
        date: 'October 2022',
        buttonText: "Read article",
        link: "https://www.calcalistech.com/ctechnews/article/hjyn7sqbi",
    },
];

export default latestNewsData;
